export const AddAdminIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.61506 14.5389C4.07239 14.5389 1.90039 14.1543 1.90039 12.6143C1.90039 11.0743 4.05839 9.67358 6.61506 9.67358C9.15772 9.67358 11.3297 11.0609 11.3297 12.6003C11.3297 14.1396 9.17172 14.5389 6.61506 14.5389Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.61479 7.47735C8.28346 7.47735 9.63679 6.12402 9.63679 4.45535C9.63679 2.78602 8.28346 1.43335 6.61479 1.43335C4.94613 1.43335 3.59279 2.78602 3.59279 4.45535C3.58679 6.11802 4.93079 7.47135 6.59346 7.47735H6.61479Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7542 5.41943V8.09277"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1183 6.75594H11.3916"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
